module.exports = __webpack_public_path__ + "static/media/01.15f224a3.png";